// extracted by mini-css-extract-plugin
export default {"resetButton":"tLGAvc4","root":"mObnFAf","collapsedFactset":"Y1I4GZg"};